import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=36fe498e&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=36fe498e&prod&scoped=true&lang=less"
import style1 from "./EditModal.vue?vue&type=style&index=1&id=36fe498e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe498e",
  null
  
)

export default component.exports